import { defineComponent } from 'vue';export default defineComponent({    name: 'customizeView',    inheritAttrs: false,    props: {    },});